import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ModalOption } from '../../shared/type/modal';

@Component({
    selector: 'app-managements-actions-modal',
    standalone: true,
    imports: [CommonModule, IonicModule, TranslateModule],
    templateUrl: './managements-actions-modal.component.html',
    styleUrl: './managements-actions-modal.component.scss',
})
export class ManagementsActionsModalComponent implements OnInit {
    @Input() modalOption!: ModalOption;
    constructor(private _modalController: ModalController) {}

    ngOnInit() {
    } 

    dismiss() {
      this._modalController.dismiss();
    }
}
